import React, { useEffect } from 'react';

import { useModal } from 'context/ModalProvider/ModalProvider';
import { useSecrets } from 'context/SecretsProvider/SecretsProvider';
import { initialiseChart } from 'features/Events/components/EventsChart/utils/initialiseChart';
import { EventData } from 'features/Events/types/eventData';

type EventsChartProps = {
  chartId: string;
  chartData: EventData[];
  minDateTimeRange: string;
  maxDateTimeRange: string;
  lineColor: string;
};

const EventsChart = ({
  chartId,
  chartData,
  minDateTimeRange,
  maxDateTimeRange,
  lineColor,
}: EventsChartProps) => {
  const { setShowModal, setModalContent } = useModal();
  const { getSecrets } = useSecrets();
  const { amchartsLicenseKey } = getSecrets();

  useEffect(() => {
    const root = initialiseChart(
      chartId,
      minDateTimeRange,
      maxDateTimeRange,
      chartData,
      lineColor,
      amchartsLicenseKey,
      setShowModal,
      setModalContent
    );

    return () => {
      root.dispose();
    };
  }, [chartData]);

  return <div data-testid="eventsChart" id={chartId} style={{ width: '100%', height: '10em' }} />;
};

export default EventsChart;
